import React from 'react'
import { formatDate } from '../../../../../utils/functions'

const MobileGiftView = () => {
	const item = JSON.parse(localStorage.getItem('giftDetails'))
	const getStatusBadgeClass = (status) => {
		switch (status?.toLowerCase()) {
			case 'delivered':
				return 'badge-success'
			case 'pending':
				return 'badge-warning'
			case 'processing':
				return 'badge-info'
			default:
				return 'badge-secondary'
		}
	}
	return (
		<div>
			<div className='mb-5 mt-5'>
				<div class='card container-fluid w-95 mb-2 shadow-card'>
					<div className='row d-flex justify-content-between align-items-center '>
						<div className=' col-9 text-center'>
							<h3 className=' letter-normal text-bold text-black'>Gift Details</h3>
						</div>
						<div className=' col-3 title-card-bg'>
							<img
								className='title-card-image ms-n4'
								src='https://cdn3d.iconscout.com/3d/premium/thumb/gift-box-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--present-surprise-wanna-shop-pack-e-commerce-shopping-illustrations-3286985.png'
								alt=''
							/>
						</div>
					</div>
				</div>
				<div className='card shadow-card container-fluid w-95 card-body mb-4'>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-normal text-black'>Order Date</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{formatDate(item?.createdAt)}</b>
							</div>
						</div>
					</div>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-normal'>Order No</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{item?.orders.orderId}</b>
							</div>
						</div>
					</div>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-normal'>Gift Type</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-success fw-normal text-start'>{item?.giftType}</b>
							</div>
						</div>
					</div>
					<div className='row mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-normal'>Achieved Date</b>
							</div>
						</div>
						<div className='col-7'>
							<div>
								<b className='text-black fw-normal text-start'>{formatDate(item?.achievedDate)}</b>
							</div>
						</div>
					</div>
					{item?.trackUrl && (
						<div className='row mb-0'>
							<div className='col-5'>
								<div>
									<b className='text-black fw-normal text-normal'>Tracking Url :</b>
								</div>
							</div>
							<div className='col-7'>
								<div>
									{/* <b className='text-black fw-normal text-start'>{formatDate(item?.achievedDate)}</b> */}
									<b>
										<a
											href={item?.trackUrl?.startsWith('https') ? item.trackUrl : `https://${item.trackUrl}`}
											target='_blank'
											rel='noopener noreferrer'
											className='text-dark font-weight-normal mt-1'
										>
											{item.trackUrl}
										</a>
									</b>
								</div>
							</div>
						</div>
					)}
				</div>
				<h3 className='source-serif-4 text-normal text-black ms-3'>Gifts Information</h3>
				<div className='card shadow-card container-fluid w-95 card-body mb-4'>
					{/* <div className='row d-flex justify-content-lg-start mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-start'> Level Name : </b>
							</div>
						</div>
						<div className='col-6'>
							<div>
								<b className='text-black fw-normal text-start'>Meta</b>
							</div>
						</div>
					</div> */}
					<div className='row d-flex justify-content-lg-start mb-2'>
						<div className='col-5'>
							<div>
								<b className='text-black fw-normal text-start'> Gift Status : </b>
							</div>
						</div>
						<div className='col-6'>
							<div>
								<b className='fw-normal text-start'>
									<span className={`badge ${getStatusBadgeClass(item.orderStatus)} fw-bold mt-1`}>{item?.orderStatus}</span>{' '}
								</b>
							</div>
						</div>
					</div>
					{item?.trackUrl && (
						<div className='row d-flex justify-content-lg-start mb-2'>
							<div className='col-5'>
								<div>
									<b className='text-black fw-normal text-start'> Tracking URL : </b>
								</div>
							</div>
							<div className='col-6'>
								<div>
									<b className='text-black fw-normal text-start'>
										<a
											href={item?.trackUrl?.startsWith('https') ? item.trackUrl : `https://${item.trackUrl}`}
											target='_blank'
											rel='noopener noreferrer'
											className='text-dark font-weight-normal mt-1'
										>
											{item.trackUrl}
										</a>
									</b>
								</div>
							</div>
						</div>
					)}
				</div>
				<h3 className='source-serif-4 text-normal text-black ms-3'>Product Information</h3>
				<div className='card shadow-card container-fluid w-95 card-body mb-3'>
					<div className='row justify-content-center align-items-center'>
						<div className='col-3'>
							<div>
								<img className='w-100' src={`${process.env.REACT_APP_RESOURCE_URL}${item.imageUrl}`} alt='' />
							</div>
						</div>
						<div className='col-9'>
							<div className='lh-1 mb-2'>
								<b className='text-normal text-sm text-black text-wrap'>{item?.gameProducts?.name}</b>
							</div>
							<div className='row d-flex justify-content-center mb-2'>
								<div className='col-6'>
									<b className='text-black text-md fw-normal text-start'>Quantity : </b>
								</div>
								<div className='col-6'>
									{' '}
									<b className='text-black text-md fw-normal text-start'>1 (Item)</b>
								</div>
							</div>
							<div className='row d-flex justify-content-center'>
								<div className='col-6'>
									<b className='text-black text-md fw-normal text-start'>Grand Total : </b>
								</div>
								<div className='col-6'>
									{' '}
									<b className='text-black text-md fw-normal text-start'>
										<sup>₹</sup>
										{item?.gameProducts?.finalPrice}
									</b>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MobileGiftView
